import * as React from 'react';
import { Image, ScrollView, StyleSheet, View } from 'react-native';
import { NativeViewGestureHandler } from 'react-native-gesture-handler';
import { useAppSelector } from 'store/hooks';
import { rem, Spacer } from 'design-system';
import SectionHeader from 'design-system/SectionHeader';
import Text from 'design-system/Text';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import useColors from 'hooks/useColors';
import { Tier } from 'features/premium/entities';
import { selectUserTier } from 'features/premium/selectors/tier';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { selectHasCashIsaPot } from '../reducers/selectors';
const FSCSImg = require('../img/FSCS.png');
const PotProductCards = ({ onPress }) => {
    const colors = useColors();
    const activeTier = useAppSelector(selectUserTier);
    const products = useAppSelector((store) => store.pots.products);
    const hasVisibleCashIsa = useAppSelector((store) => store.pots.hasVisibleCashIsa);
    const hasCashIsaPot = useAppSelector(selectHasCashIsaPot);
    const { paddingHorizontalStyle, paddingHorizontal } = useAppFrameDimensions(true);
    const interestPotProductsTierRateMap = useAppSelector((store) => store.pots.interestPotProductsTierRateMap);
    if (products?.length) {
        return (<>
        <SectionHeader largeVerticalMargins horizontalMargins style={paddingHorizontalStyle}>
          Create your first pot
        </SectionHeader>
        <NativeViewGestureHandler disallowInterruption>
          <ScrollView horizontal contentContainerStyle={{ paddingHorizontal: paddingHorizontal + rem(8) }} showsHorizontalScrollIndicator={false}>
            {products.map((product) => {
                if (product.isVisible && product.type !== 'BASIC' && (!product.isProductCashISA || hasCashIsaPot)) {
                    const ultimateTierRate = interestPotProductsTierRateMap?.[product.id]?.[Tier.ultimate];
                    const isRecommended = hasVisibleCashIsa && hasCashIsaPot
                        ? product.isRecommended && product.isProductCashISA
                        : product.isRecommended;
                    const words = product.name.split(' ');
                    const finalName = words.length > 2 ? `${words.slice(0, -2).join(' ')}\n${words.slice(-2).join(' ')}` : product.name;
                    return (<View style={styles.cardWrapper} key={product.id}>
                    <TouchableBounceCard onDark withPadding noMargin style={styles.card} onPress={() => onPress(product.id)}>
                      <View style={styles.graphicsWrapper}>
                        {!!product.fscsBrochure && (<Image source={FSCSImg} style={styles.fscsImg} tintColor={colors.elements.secondary}/>)}
                      </View>

                      <Spacer h={8}/>

                      {!!isRecommended && (<>
                          <Text Text-12 Primary>
                            {product.isProductCashISA ? 'MOST POPULAR' : 'RECOMMENDED'}
                          </Text>
                          <Spacer h={4}/>
                        </>)}

                      <Text Text-16>{finalName}</Text>

                      <Spacer h={4}/>

                      <Text TextThin-14 Secondary>
                        {activeTier !== Tier.ultimate ? 'up to ' : ''}
                        <Text Text-14 Primary>
                          {ultimateTierRate}%
                        </Text>
                        {' AER'}
                        {product.interestPaymentFrequency
                            ? `, paid ${product.interestPaymentFrequency.toLowerCase()}`
                            : ''}
                      </Text>
                    </TouchableBounceCard>
                  </View>);
                }
                return <View key={product.id}/>;
            })}
          </ScrollView>
        </NativeViewGestureHandler>
      </>);
    }
    return null;
};
export default React.memo(PotProductCards);
const styles = StyleSheet.create({
    cardWrapper: {
        marginHorizontal: rem(8),
    },
    card: {
        flex: 1,
        width: rem(150),
        justifyContent: 'center',
    },
    graphicsWrapper: {
        flexDirection: 'row',
    },
    fscsImg: {
        width: rem(35),
        height: rem(24),
    },
});
